import React from "react";
import BaseLayout from "../components/BaseLayout/BaseLayout";
import WhitepaperLayout from "../components/WhitepaperLayout";
import { useDocumentTitle } from "../hooks/setDocumentTitle";

export default function Whitepaper() {
  useDocumentTitle("Whitepaper");
  return (
    <div className="roadmap">
      <BaseLayout>
        <WhitepaperLayout />
      </BaseLayout>
    </div>
  );
}
